<template>
  <div class="wrapper">
    <div class="contentContainer">
      <div class="contentContainer--body">
        <slot> </slot>
      </div>
      <div class="contentContainer--footer">
        <Footer />
      </div>
    </div>
  </div>
</template>
<script>
import Footer from "@/components/shared/Footer/Footer.vue";
const globalMapper = createNamespacedHelpers('global');
import { createNamespacedHelpers } from "vuex";

export default {
  components: {
    Footer,
  },
  data() {
    return {
      height: document.documentElement.clientHeight,
      width: document.documentElement.clientWidth,
    };
  },
  mounted() {
    this.setAllFalse()
    this.SET_NAME_PAGE('topPage')
  },
  computed: {
    namePage(){
      return this.$t('topPage')
    }
  },
  methods: {
    ...globalMapper.mapActions([
      "setAllFalse",
    ]),
    ...globalMapper.mapMutations([
      "SET_NAME_PAGE"

    ]),
  },
};
</script>
